import React from "react"
import {
  InterferometricStackSearchResultsType, ProductImageSearchResultsType,
  SearchResultsType
} from "../../../types/product";
import ProductList from "../../shared/search-results/ProductList";
import InterferometricStacksList from "../../shared/search-results/InterferometricStacksList";

interface PropsType {
  searchResults: SearchResultsType,
  isInterferometricStackSearch: boolean
}

const BodySearchResultsSidebar = (props: PropsType) => {
  const {
    searchResults,
    isInterferometricStackSearch
  } = props;

  return isInterferometricStackSearch
    ? <InterferometricStacksList stacks={(searchResults as InterferometricStackSearchResultsType).stacks} />
    : <ProductList items={(searchResults as ProductImageSearchResultsType).items} detailsVersion={false} />
};

export default BodySearchResultsSidebar;
